import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Platform } from "@/components/Platform";
import { Marketplace } from "@/components/Marketplace";
import { Sat2Farm } from "@/components/Sat2Farm";
import { Pricing } from "@/components/Pricing";
import { Leadership } from "@/components/Leadership";
import { Partners } from "@/components/Partners";
import { VideoHub } from "@/components/VideoHub";
import { Collateral } from "@/components/Collateral";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { JoinDialog } from "@/components/JoinDialog";
import { Lightbox } from "@/components/Lightbox";
import { FEATURED_VIDEO } from "@/data/site";

function App() {
  const [joinOpen, setJoinOpen] = useState(false);
  const [playing, setPlaying] = useState(null);
  const [poster, setPoster] = useState(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const openJoin = () => setJoinOpen(true);

  return (
    <div className="App" data-testid="app-root">
      <Header onJoin={openJoin} />
      <main>
        <Hero onJoin={openJoin} onWatch={() => setPlaying(FEATURED_VIDEO)} />
        <Marquee />
        <Platform onPoster={setPoster} />
        <Marketplace onJoin={openJoin} />
        <Sat2Farm onPoster={setPoster} />
        <Pricing onJoin={openJoin} />
        <Leadership onPoster={setPoster} />
        <Partners onJoin={openJoin} />
        <VideoHub playing={playing} setPlaying={setPlaying} />
        <Collateral onPoster={setPoster} />
        <Contact />
      </main>
      <Footer onJoin={openJoin} />
      <JoinDialog open={joinOpen} onClose={() => setJoinOpen(false)} />
      <Lightbox src={poster} onClose={() => setPoster(null)} />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
